/* eslint-disable */
import axios from "axios"

export default {
  methods: {
    isApiCanceled(error) {
      if (axios.isCancel(error)) {
        return true;
      }
      return false;
    }
  }
};